'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var prefix = 'far';
var iconName = 'gas-pump';
var width = 512;
var height = 512;
var aliases = [9981];
var unicode = 'f52f';
var svgPathData = 'M256 48c8.8 0 16 7.2 16 16V192H80V64c0-8.8 7.2-16 16-16H256zm16 192V464H80l0-224H272zM32 64V464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h8H80 272h48 8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0V304h8c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V155.9c0-19.1-7.6-37.4-21.1-50.9L417 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33V160c0 29.8 20.4 54.9 48 62V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64z';
exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, aliases, unicode, svgPathData]
};
exports.faGasPump = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;